import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AlertService } from "src/app/providers/alert.service";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AlertForEmailComponent } from "src/app/shared/components/alert-for-email/alert-for-email.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { InviteFriendsTextComponent } from "src/app/shared/components/invite-friends-text/invite-friends-text.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { environment } from "src/environments/environment";

@Component({
  selector: "sm-share",
  templateUrl: "./share.component.html",
  styleUrls: ["./share.component.scss"],
})
export class ShareComponent implements OnInit, OnDestroy {
  selectedValue: any = "1";
  whatsappNumbers: any = "";
  emailAddresses: any = "";
  apisub: Subscription;
  constructor(
    private _navservice: NavigationService,
    private _snackbar: MatSnackBar,
    private _modelRef: MatDialog,
    private apiservice: ApiService,
    private loaderservice: LoaderServiceService,
    private alertservice: AlertService,
    private router: Router
  ) {
    this._navservice.hideSidebarAndNav = false;
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      console.log(resdata);

      if (resdata.responseType === SM_CONSTANTS.RESULT_API_SEND_EMAIL) {
        if (resdata.result) {
          this.loaderservice.showLoader = false;
          this.whatsappNumbers = "";
          this.emailAddresses = "";
          if (
            resdata.result.unsuccessfull_emails &&
            resdata.result.unsuccessfull_emails.length > 0
          ) {
            const dialogRef1 = this._modelRef.open(AlertForEmailComponent, {
              width: "600px",
              data: {
                title: "THANK YOU!",
                message1:
                  "Just wanted to say thanks for using the LookzUp platform and supporting us by sharing it with others. We hope you are enjoying using it as much as we do by providing you with the best industry solution. We'll inform you once the cash reward going to credited in your account.",
                message2: resdata.result.unsuccessfull_emails.join(", "),
                message3:
                  "The following recipient unsubscribed to email sending from LookzUp platform. Contact support to send him/her email.",
                okbtn: "Ok",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              },
              disableClose: true,
            });
          } else {
            this._modelRef.open(CustomConfirmDialogComponent, {
              width: "600px",
              data: {
                title: "THANK YOU!",
                message:
                  "Just wanted to say thanks for using the LookzUp platform and supporting us by sharing it with others. We hope you are enjoying using it as much as we do by providing you with the best industry solution. We'll inform you once the cash reward going to credited in your account.",
                okbtn: "Ok",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              },
              disableClose: true,
            });
          }
        }
      }
      if (resdata.responseType === SM_CONSTANTS.RESULT_API_SEND_WHATSAPP) {
        if (resdata.result) {
          this.loaderservice.showLoader = false;
          this.selectedCountryCode = this.countryList.find(
            (country) => country.dial_code === "+91"
          );
          this.whatsappNumbers = "";
          this.emailAddresses = "";
          this._modelRef.open(CustomConfirmDialogComponent, {
            width: "600px",
            data: {
              title: "THANK YOU!",
              message:
                "Just wanted to say thanks for using the LookzUp platform and supporting us by sharing it with others. We hope you are enjoying using it as much as we do by providing you with the best industry solution. We'll inform you once the cash reward going to credited in your account.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        }
      }
    });
  }

  ngOnInit(): void {}
  changeChip(value: any) {
    this.whatsappNumbers = "";
    this.emailAddresses = "";
    this.selectedValue = value;
  }
  send() {
    if (this.selectedValue == "1") {
      this.loaderservice.showLoader = true;

      // Remove leading and trailing commas and spaces
      this.whatsappNumbers = this.whatsappNumbers.replace(
        /^[,\s]+|[,\s]+$/g,
        ""
      );

      // Ensure that spaces after commas are removed
      this.whatsappNumbers = this.whatsappNumbers.replace(/\s*,\s*/g, ",");

      let splittedNumbers = this.whatsappNumbers.split(",");
      let countryCode = this.selectedCountryCode.dial_code;
      countryCode = countryCode.slice(1);

      let formattedNumbers = splittedNumbers.map((item: any) => {
        return countryCode.concat(item);
      });
      // platform type not being sent by default in business - default check in backend
      let obj = {
        recipient: formattedNumbers.join(","),
        messageTitle: null,
        senderName: localStorage.getItem(SM_CONSTANTS.OWNER_NAME),
        type: 2,
        link: null,
        messageBody: null,
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        profile_code: localStorage.getItem(SM_CONSTANTS.PROFILE_CODE),
        recipientName: "New Invitee",
      };
      console.log(obj);

      this.apiservice.sendWhatsAppMessage(obj);
    } else if (this.selectedValue == "2") {
      // Remove leading and trailing commas and spaces
      this.emailAddresses = this.emailAddresses.replace(/^[,\s]+|[,\s]+$/g, "");

      // Ensure that spaces after commas are removed
      this.emailAddresses = this.emailAddresses.replace(/\s*,\s*/g, ",");

      let emailContents = this.emailAddresses.split(",");

      if (emailContents.length > 5) {
        this._modelRef.open(CustomConfirmDialogComponent, {
          width: "500px",
          data: {
            title: "Alert",
            message:
              "You can send maximum 5 invitation E-mails at once. Send the extra ones in another try.",
            okbtn: "Ok",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
      } else {
        this.loaderservice.showLoader = true;
        let obj = {
          recipient: this.emailAddresses,
          senderName: localStorage.getItem(SM_CONSTANTS.OWNER_NAME),
          subject: null,
          message: null,
          type: 2,
          accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          profile_code: localStorage.getItem(SM_CONSTANTS.PROFILE_CODE),
        };

        console.log(obj);

        this.apiservice.sendEmail(obj);
      }
    }
  }
  inviteFriends() {
    this._modelRef.open(InviteFriendsTextComponent, {
      width: "735px",
      data: {
        title: "Invite Friends",
        ref: this._modelRef,
      },
    });
  }

  copyText() {
    let msg =
      "Hey, I found this great platform for Beauty, Grooming and Fitness businesses. You can manage your Salon, Beauty Parlor, Spa, Make-up studio, Yoga center, Fitness studio or Gym with this amazing mobile and web app. Sign-up with this link:" +
      "\n\n" +
      environment.base_lookzup_business_url +
      "/login?code=" +
      localStorage.getItem(SM_CONSTANTS.PROFILE_CODE);

    navigator.clipboard
      .writeText(msg)
      .then(() => {
        this._snackbar.open("Referral invitation link copied", "Ok", {
          duration: 3000,
        });
        // Success message or feedback can be added here
        // alert('Message copied to clipboard');
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  }

  shareFacebook() {
    let link =
      "https://www.facebook.com/sharer/sharer.php?u=" +
      environment.base_lookzup_business_url +
      "/login?code=" +
      encodeURIComponent(localStorage.getItem(SM_CONSTANTS.PROFILE_CODE)!);
    window.open(link, "_blank");
  }

  shareTwitter() {
    let link =
      "https://twitter.com/intent/tweet?url=" +
      environment.base_lookzup_business_url +
      "/login?code=" +
      localStorage.getItem(SM_CONSTANTS.PROFILE_CODE) +
      "&text=Hey,%20I%20found%20this%20great%20platform%20for%20Beauty,%20Grooming%20and%20Fitness%20businesses.%20You%20can%20manage%20your%20Salon,%20Beauty%20Parlor,%20Spa,%20Make-up%20studio,%20Yoga%20center,%20Fitness%20studio%20or%20Gym%20with%20this%20amazing%20mobile%20and%20web%20app.%20Sign-up%20with%20this%20link%3A";
    window.open(link, "_blank");
  }

  shareLinkedin() {
    let link =
      "https://www.linkedin.com/sharing/share-offsite/?url=" +
      encodeURIComponent(
        environment.base_lookzup_business_url +
          "/login?code=" +
          localStorage.getItem(SM_CONSTANTS.PROFILE_CODE)!
      ) +
      "&mini=true&title=" +
      encodeURIComponent(
        "Hey, I found this great platform for Beauty, Grooming and Fitness businesses. You can manage your Salon, Beauty Parlor, Spa, Make-up studio, Yoga center, Fitness studio or Gym with this amazing mobile and web app. Sign-up with this link:"
      );
    window.open(link);
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === "+91"
  );

  searchString: FormControl = new FormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

  checkdis() {
    if (this.selectedValue == "1") {
      if (
        this.whatsappNumbers &&
        this.whatsappNumbers.trim() != "" &&
        this.whatsappNumbers != undefined &&
        this.whatsappNumbers.length >= 3 && this.whatsappNumbers.length <= 17
      ) {
        return false;
      } else {
        return true;
      }
    } else if (this.selectedValue == "2") {
      if (
        !this.emailAddresses ||
        this.emailAddresses.trim() === "" ||
        this.emailAddresses == undefined
      ) {
        return true;
      }
      // Clean and split the email addresses
      let cleanedEmails = this.emailAddresses
        .replace(/^[,\s]+|[,\s]+$/g, "")
        .replace(/\s*,\s*/g, ",")
        .split(",");

      // Check for invalid emails
      let hasInvalidEmail = cleanedEmails.some(
        (email: any) => !this.isValidEmail(email)
      );

      // Disable if any invalid email exists
      return hasInvalidEmail;
    }
    return true; // Default disable
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

     openLink(): void {
      this.router.navigate(['/share-customer-app'])
  }
}
